<template>
  <div class="">
    <div class="card">
      <div class="card-title">EXCERPT PREVIEW</div>
      <div class="preview-excerpt">
        <img :src="ad.tooltipImage" />
        <div class="ad-text">
          <div class="ad-text-title">{{ ad.tooltipTitle }}</div>
          <div class="ad-text-message">{{ ad.tooltipDescription }}</div>
        </div>
      </div>
    </div>

    <div class="card preview">
      <div class="card-title">CONTENT PREVIEW</div>
      <div class="ad-preview">
        <div class="ad-title">{{ ad.mainHeader }} <i class="fa fa-times"></i></div>
        <div class="ad-container">
          <div class="ad-content">
            <img class="ad-image" :src="ad.mainImage" />
            <!--div class="ad-content-title">{{ ad.mainTitle }}</div-->
            <div class="ad-content-body" v-html="ad.mainBody"></div>
            <div class="ad-cta-container">
              <a class="ad-cta" href="javascript:;">{{ ad.ctaText }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'web-ad-preview',
  computed: {
    ad () { return this.$store.state.ads.adItem.edited }
  }
}
</script>

<style lang="scss" scoped>
.card {
  padding: 15px;
  margin-top: 15px;
}
.card-title{
  font-weight: 700;
  font-size: 12px;
  color: #0D79F2
}
.preview-excerpt {
  margin-top: 15px;
  position: relative;
  background-color: #fff;
  padding: 10px;
  height: 90px;
  border-radius: 3px;
  border: 1px solid rgba(0,0,0,0.15);
  box-shadow: 0 2px 4px rgba(0,0,0,0.35);

  & img {
    position: absolute;
    top: 10px;
    left: 15px;
    width: 70px;
    height: 70px;
  }

  & .ad-text {
    margin-left: 90px;
    padding: 10px 0;
  }

  & .ad-text-title {
    font-size: 17px;
    font-weight: 700;
    color: #26BCAC;
    white-space: nowrap; 
    overflow: hidden;
    text-overflow: ellipsis;
  }

  & .ad-text-message {
    color: #333;
    font-size: 14px;
    white-space: nowrap; 
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.ad-preview {
  margin-top: 15px;
  background-color: #fff;
  border: 1px solid rgba(0,0,0,0.15);
  box-shadow: 0 2px 4px rgba(0,0,0,0.35);

  & .ad-title {
    position: relative;
    text-align: center;
    font-weight: 700;
    font-size: 16px;
    padding: 15px;

    & i {
      position: absolute;
      top: 18px;
      right: 15px;
      color: #F20D0D;
    }
  }

  & .ad-image {
    display: block;
    width: 100%;
  }

  & .ad-content-body {
    padding: 15px;
  }

  & .ad-cta-container {
    text-align: center;
  }

  & .ad-cta {
    background-color: #26BCAC;
    font-weight: 400;
    font-size: 16px;
    color: #fff;
    text-decoration: none;
    display: inline-block;
    text-align: center;
    padding: 15px;
    margin-bottom: 15px;
    border-radius: 3px;
    -webkit-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
  }
}

@media screen and (max-width: 430px) {
  .preview {
    padding-bottom: 100px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MarketingAds/WebAdPreview.vue